const home = {
  hero_badge: 'Платформа медицинского туризма Турции',
  hero_title_1: 'Восстановите',
  hero_title_2: 'Здоровье',
  hero_title_3: 'в Турции',
  hero_subtitle: 'Откройте для себя аккредитованные медицинские учреждения Турции для пациентов из-за рубежа. Планируйте поездку самостоятельно или доверьте всю организацию посредническому агентству.',
  hero_stat_institutions: 'Аккредитованных учреждений',
  hero_stat_patients: 'Довольных пациентов',
  hero_stat_doctors: 'Врачей-специалистов',
  hero_stat_countries: 'Стран',
  hero_accreditation_label: 'Аккредитация:',
  hero_search_title: 'Поиск лечения',
  hero_step1_label: 'Вид лечения',
  hero_step1_placeholder: 'Введите или выберите лечение...',
  hero_step2_label: 'Предпочтение организации',
  hero_self_organize: 'Я могу организовать поездку самостоятельно',
  hero_agency_organize: 'Пусть агентство организует мою больницу и поездку',
  hero_step3_agency: 'Посредническое агентство',
  hero_step3_institution: 'Медицинское учреждение',
  hero_step3_optional: '(необязательно)',
  hero_all_agencies: 'Посмотреть все агентства',
  hero_all_institutions: 'Посмотреть все учреждения',
  hero_city_label: 'Город',
  hero_all_cities: 'Все города',
  hero_search_agencies: 'Исследовать агентства',
  hero_search_institutions: 'Исследовать медицинские учреждения',
  hero_trust_note: 'Все учреждения одобрены Министерством здравоохранения Республики Турция',

  steps_title: '3 шага для использования платформы',
  steps_subtitle: 'Найти подходящее медицинское учреждение теперь намного проще',
  step1_number: 'Шаг 1',
  step1_title: 'Зарегистрироваться бесплатно',
  step1_desc: 'Зарегистрируйтесь бесплатно на платформе и получите мгновенный доступ ко всем функциям',
  step2_number: 'Шаг 2',
  step2_title: 'Просмотр учреждений',
  step2_desc: 'Сравнивайте аккредитованные медицинские учреждения, изучайте врачей и услуги',
  step3_number: 'Шаг 3',
  step3_title: 'Отправить запрос на обратный звонок',
  step3_desc: 'Отправьте запрос на обратный звонок в выбранное учреждение, они позвонят вам на вашем языке',

  treatment_badge: 'Области лечения',
  treatment_title: 'Наиболее популярные',
  treatment_title_highlight: 'виды лечения в Турции',
  treatment_subtitle: 'Тысячи международных пациентов выбирают Турцию каждый год. Откройте для себя аккредитованные учреждения в областях лечения ниже.',
  treatment_view_institutions: 'Посмотреть учреждения',
  treatment_view_all: 'Посмотреть все области лечения',

  institutions_title: 'Медицинские',
  institutions_title_highlight: 'учреждения',
  institutions_subtitle: 'Найдите наиболее подходящее среди одобренных медицинских учреждений',
  institutions_view_all: 'Посмотреть все учреждения',
  institutions_empty: 'Пока нет одобренных учреждений.',
  agencies_badge: 'Организация и туристические услуги',
  agencies_title: 'Агентства',
  agencies_title_highlight: 'медицинского туризма',
  agencies_subtitle: 'Агентства, которые организуют ваши медицинские услуги вместе с потребностями в путешествиях, проживании и туризме',
  agencies_view_all: 'Посмотреть все агентства',
  agencies_empty_title: 'Пока нет агентств',
  agencies_empty_desc: 'Агентства будут перечислены в ближайшее время.',
  agency_label: 'Агентство',
  consultation_available: 'Можно отправить запрос на консультацию',
  service_flight: 'Перелёт и трансфер',
  service_hotel: 'Бронирование отеля',
  service_tour: 'Туристический тур',
  service_translation: 'Перевод',
  service_vip: 'VIP-встреча',

  why_title: 'Почему',
  why_title_highlight: 'выбрать нас?',
  why_subtitle: 'Ваш надёжный гид для международных пациентов, ищущих медицинскую помощь в Турции',
  why_stat_institutions: 'Аккредитованных учреждений',
  why_stat_treatments: 'Областей лечения',
  why_stat_countries: 'Стран',
  why_stat_satisfaction: 'Удовлетворённость пациентов',
  why_feature1_title: 'Аккредитованные учреждения',
  why_feature1_desc: 'Все медицинские учреждения на платформе — проверенные учреждения с аккредитацией JCI, ISO или Министерства здравоохранения Турции.',
  why_feature2_title: 'Многоязычная поддержка',
  why_feature2_desc: 'Легко фильтруйте учреждения, предлагающие поддержку общения на арабском, английском, русском и других языках.',
  why_feature3_title: 'Детальное сравнение',
  why_feature3_desc: 'Сравнивайте учреждения бок о бок по их услугам, врачам, местоположению и отзывам пациентов.',
  why_feature4_title: 'Запрос обратного звонка',
  why_feature4_desc: 'Отправьте запрос на обратный звонок напрямую в понравившееся учреждение. Учреждение позвонит вам с языковой поддержкой.',
  why_feature5_title: 'Доступная стоимость',
  why_feature5_desc: 'Получите медицинскую помощь мирового класса по ценам на 50-70% ниже, чем в Европе и США.',
  why_feature6_title: 'Расположение и транспорт',
  why_feature6_desc: 'Откройте для себя учреждения во всех городах Турции, особенно в Стамбуле, Анкаре, Измире и Анталье.',

  inst_approved_badge: 'Одобрено',
  inst_explore: 'Подробнее',
  inst_doctor_count: '{{count}} врач',
  inst_no_approved: 'Пока нет одобренных учреждений.',
  agencies_service_badge: 'Агентство медицинского туризма',
  agencies_consult: 'Можно отправить запрос на консультацию',
  agencies_explore: 'Подробнее',

  process_badge: 'Шаг за шагом',
  process_title: 'Процесс',
  process_title_highlight: 'ЭКО',
  process_subtitle: 'Узнайте каждый этап лечения ЭКО понятным образом',
  process_step_label: 'Шаг {{num}}',
  process_step1_title: 'Предварительная оценка',
  process_step1_desc: 'Составляется план лечения с детальным обследованием, гормональными тестами и УЗИ.',
  process_step2_title: 'Стимуляция яичников',
  process_step2_desc: 'Яичники стимулируются гормональными препаратами и отслеживается развитие яйцеклеток.',
  process_step3_title: 'Забор яйцеклеток',
  process_step3_desc: 'Зрелые яйцеклетки собираются под лёгкой анестезией.',
  process_step4_title: 'Оплодотворение',
  process_step4_desc: 'Яйцеклетки и сперматозоиды объединяются в лабораторных условиях.',
  process_step5_title: 'Развитие эмбриона',
  process_step5_desc: 'Образовавшиеся эмбрионы развиваются в лаборатории в течение 3-5 дней.',
  process_step6_title: 'Перенос эмбриона',
  process_step6_desc: 'Эмбрион наивысшего качества помещается в матку и ожидается тест на беременность.',

  explore_badge: 'Откройте Турцию',
  explore_title: 'Познакомьтесь с',
  explore_title_highlight: 'Турцией',
  explore_subtitle: 'Не упустите возможность исследовать эту прекрасную страну, приезжая в Турцию на лечение.',
  explore_destinations: 'Направления',
  explore_culture: 'Культура и жизнь',
  explore_about_title: 'О Турции',
  explore_about_subtitle: 'Города, направления и практическая информация',
  explore_about_desc: 'Исторический полуостров Стамбула, Эгейское побережье Измира, бирюзовые воды Антальи и многое другое. Откройте для себя самые красивые направления Турции.',
  explore_about_highlights: 'Стамбул,Измир,Анталья,Каппадокия',
  explore_culture_title: 'Культура в Турции',
  explore_culture_subtitle: 'Этикет, кухня и традиции',
  explore_culture_desc: 'Турецкое гостеприимство, чайная культура, вкусная кухня и богатые традиции. Всё, что нужно знать перед поездкой в Турцию.',
  explore_culture_highlights: 'Турецкая кухня,Этикет,Традиции,Социальная жизнь',
  explore_cta: 'Исследовать',
  explore_stat1: '81 провинция, бесчисленные направления',
  explore_stat2: 'Богатая турецкая кухня',
  explore_stat3: '10 000 лет истории',

  faq_badge: 'Библиотека знаний',
  faq_title: 'Часто задаваемые',
  faq_title_highlight: 'вопросы',
  faq_subtitle: 'Любопытные вопросы о процессе ЭКО',
  faq_q1: 'Что такое лечение ЭКО и как оно работает?',
  faq_a1: 'ЭКО (экстракорпоральное оплодотворение) — это процесс объединения яйцеклеток и сперматозоидов в лабораторных условиях и помещения полученного эмбриона в матку матери. Процесс лечения состоит из гормональной терапии, забора яйцеклеток, оплодотворения и переноса эмбриона.',
  faq_q2: 'Сколько длится лечение ЭКО?',
  faq_a2: 'Один цикл лечения ЭКО занимает в среднем 4-6 недель. Этот период охватывает подготовку, гормональную терапию, забор яйцеклеток и перенос эмбриона.',
  faq_q3: 'Какова успешность лечения ЭКО?',
  faq_a3: 'Успешность зависит от таких факторов, как возраст, качество яйцеклеток, качество спермы и общее состояние здоровья. Успешность составляет около 40-50% для женщин до 35 лет и снижается с возрастом.',
  faq_q4: 'Болезненно ли лечение ЭКО?',
  faq_a4: 'Большая часть процесса лечения безболезненна. Забор яйцеклеток проводится под лёгкой анестезией и дискомфорт минимален. Перенос эмбриона — безболезненная процедура.',
  faq_q5: 'Есть ли возрастное ограничение для лечения ЭКО?',
  faq_a5: 'В Турции законный возрастной предел для лечения ЭКО составляет 18-49 лет для женщин и 18-60 лет для мужчин. Поскольку успешность снижается с возрастом, выгоднее начинать лечение особенно до 35 лет.',
  faq_q6: 'Какова стоимость лечения ЭКО?',
  faq_a6: 'Стоимость варьируется в зависимости от выбранного центра, протокола лечения и использования медикаментов. В Турции в среднем от 15 000 до 30 000 турецких лир. Некоторые частные медицинские страховки могут обеспечить частичное покрытие.',

  // Медицинские услуги
  treat_sac_ekimi_title: 'Пересадка волос',
  treat_sac_ekimi_subtitle: 'Техника FUE / DHI',
  treat_sac_ekimi_desc: 'Одна из наиболее популярных услуг медицинского туризма в мире. Постоянные и естественные результаты.',
  treat_sac_ekimi_tag: 'Самое популярное',
  treat_dis_tedavisi_title: 'Стоматологическое лечение',
  treat_dis_tedavisi_subtitle: 'Имплантат / Виниры / Цирконий',
  treat_dis_tedavisi_desc: 'Турция — самое популярное направление в Европе для эстетической стоматологии и имплантации.',
  treat_dis_tedavisi_tag: 'Очень востребовано',
  treat_goz_ameliyati_title: 'Операция на глазах',
  treat_goz_ameliyati_subtitle: 'LASIK / LASEK / Линза',
  treat_goz_ameliyati_desc: 'Постоянные решения для зрения со специализированными клиниками лазерной хирургии глаза.',
  treat_goz_ameliyati_tag: '',
  treat_estetik_cerrahi_title: 'Эстетическая хирургия',
  treat_estetik_cerrahi_subtitle: 'Ринопластика / Липосакция / BBL',
  treat_estetik_cerrahi_desc: 'Безопасные и качественные операции с опытными специалистами пластической хирургии.',
  treat_estetik_cerrahi_tag: 'Высокий спрос',
  treat_ortopedi_title: 'Ортопедия и травматология',
  treat_ortopedi_subtitle: 'Колено / Бедро / Позвоночник',
  treat_ortopedi_desc: 'Экспертные ортопедические центры по замене суставов, хирургии позвоночника и спортивным травмам.',
  treat_ortopedi_tag: '',
  treat_tup_bebek_title: 'Лечение ЭКО',
  treat_tup_bebek_subtitle: 'ЭКО / ИКСИ / ПГТ',
  treat_tup_bebek_desc: 'Осуществите мечту о семье с аккредитованными центрами ЭКО в Турции.',
  treat_tup_bebek_tag: '',
  treat_kardiyoloji_title: 'Кардиология',
  treat_kardiyoloji_subtitle: 'Кардиохирургия / Ангиография',
  treat_kardiyoloji_desc: 'Кардиологические центры, предоставляющие услуги мирового класса при лечении сердечно-сосудистых заболеваний.',
  treat_kardiyoloji_tag: '',
  treat_onkoloji_title: 'Онкология',
  treat_onkoloji_subtitle: 'Лечение рака / Радиотерапия',
  treat_onkoloji_desc: 'Обнадёживающий процесс с онкологическими центрами, использующими новейшие методы диагностики рака.',
  treat_onkoloji_tag: '',
  treat_obezite_title: 'Бариатрическая хирургия',
  treat_obezite_subtitle: 'Рукав желудка / Шунтирование',
  treat_obezite_desc: 'Сделайте шаг к здоровой жизни со специалистами в области бариатрической и метаболической хирургии.',
  treat_obezite_tag: '',
  treat_checkup_title: 'Чекап и скрининг',
  treat_checkup_subtitle: 'Комплексный медицинский осмотр',
  treat_checkup_desc: 'Сохраните своё здоровье с пакетами ранней диагностики и комплексного скрининга.',
  treat_checkup_tag: '',
  treat_noroloji_title: 'Неврология и нейрохирургия',
  treat_noroloji_subtitle: 'Мозг / Нервная система',
  treat_noroloji_desc: 'Комплексное лечение в специализированных центрах неврологических заболеваний и нейрохирургии.',
  treat_noroloji_tag: '',
  treat_uroloji_title: 'Урология',
  treat_uroloji_subtitle: 'Почки / Мочевой пузырь / Простата',
  treat_uroloji_desc: 'Безопасные решения со специализированными клиниками в диагностике и лечении урологических заболеваний.',
  treat_uroloji_tag: '',
  treat_dermatoloji_title: 'Дерматология',
  treat_dermatoloji_subtitle: 'Кожа / Лазер / Эстетика',
  treat_dermatoloji_desc: 'Здоровая кожа со специализированными клиниками кожных болезней и эстетической дерматологии.',
  treat_dermatoloji_tag: '',
  treat_fizik_tedavi_title: 'Физиотерапия',
  treat_fizik_tedavi_subtitle: 'Реабилитация / Физиотерапия',
  treat_fizik_tedavi_desc: 'Быстрое выздоровление со специализированными центрами физической терапии и реабилитации.',
  treat_fizik_tedavi_tag: '',
  treat_organ_nakli_title: 'Трансплантация органов',
  treat_organ_nakli_subtitle: 'Почка / Печень / Сердце',
  treat_organ_nakli_desc: 'Новая жизнь с опытными трансплантационными центрами.',
  treat_organ_nakli_tag: '',

  cta_badge: 'Для учреждений',
  cta_title: 'Добавьте своё медицинское учреждение',
  cta_title_highlight: 'на платформу',
  cta_subtitle: 'Охватите больше пациентов. Продвигайте своё учреждение с бесплатным или Pro-членством, получайте запросы на консультации и укрепляйте своё онлайн-присутствие.',
  cta_register: 'Создать аккаунт учреждения',
  cta_more_info: 'Подробнее',
  cta_stat_centers: 'Зарегистрированных центров',
  cta_stat_consultations: 'Запросов на консультацию',
  cta_stat_completed: 'Завершённых консультаций',
  cta_stat_cities: 'Городов',
};

export default home;
